<template>
	<div id="financial-information" class="tab-pane fade">
		<div class="table-responsive">
			<table v-if="!isEmpty(financialInformation)" class="table table-sm" aria-describedby="financial-information">
				<tbody>
					<tr>
						<td>Annual Turnover</td>
						<td>{{ financialInformation.annual_turnover_details.name | placeholder }}</td>
					</tr>
					<tr>
						<td>Investment Horizon</td>
						<td>{{ financialInformation.investment_horizon_details.name | placeholder }}</td>
					</tr>
					<tr>
						<td>Investment Objectives</td>
						<td>{{ financialInformation.investment_objectives_details.name | placeholder }}</td>
					</tr>
					<tr>
						<td>Investment Knowledge</td>
						<td>{{ financialInformation.investment_knowledge_details.name | placeholder }}</td>
					</tr>
					<tr>
						<td>Risk Tolerance</td>
						<td>{{ financialInformation.risk_tolerance_details.name | placeholder }}</td>
					</tr>
					<tr>
						<td>Estimated Amount of the First Deposit</td>
						<td>{{ financialInformation.expected_first_deposit | toCurrency('GHS') | placeholder }}</td>
					</tr>
					<tr>
						<td>Planned Investment in the First 12 months</td>
						<td>{{ financialInformation.planned_investment_amount | toCurrency('GHS') | placeholder }}</td>
					</tr>
					<!-- <tr>
						<td>Source of Funds</td>
						<td><a href="#view-source-of-funds" data-toggle="modal">View</a></td>
					</tr> -->
				</tbody>
			</table>
			<div v-else>
				<p>No financial Information.</p>
			</div>
		</div>

		<!-- <view-source-of-funds-modal-component :source-of-funds="sourceOfFunds"></view-source-of-funds-modal-component> -->
	</div>
</template>

<script>
export default {
	computed: {
		sourceOfFunds: function () {
			return JSON.parse(this.financialInformation.source_of_funds);
		},
	},
	props: ['financialInformation'],
};
</script>
